export const theme = {
  colors: {
    primary: {
      DEFAULT: '#F59E0B', // Warm amber — brand accent
      light: '#FBBF24',
      dark: '#D97706',
    },
    secondary: {
      DEFAULT: '#171717', // Near-black (stone-900)
      light: '#292524',
      dark: '#0A0A0A',
    },
    accent: {
      DEFAULT: '#F43F5E', // Rose accent
      light: '#FB7185',
      dark: '#E11D48',
    },
    background: {
      DEFAULT: '#FAFAF9', // Warm paper (stone-50)
      paper: '#FFFFFF',
      dark: '#0C0A09',
    },
    text: {
      primary: '#1C1917',
      secondary: '#57534E',
      light: '#FFFFFF',
    }
  },
  fonts: {
    heading: '"Poppins", sans-serif',
    body: '"Inter", sans-serif',
  },
  shadows: {
    small: '0 1px 2px rgba(0,0,0,0.05), 0 2px 8px rgba(0,0,0,0.06)',
    medium: '0 6px 16px -4px rgba(0,0,0,0.10)',
    large: '0 16px 32px -8px rgba(0,0,0,0.16)',
  }
};